import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../../utils/helpers/model.helper';
import { AdditionalImage } from './additional-image.model';
import { Labels } from './labels.model';
import { Logo } from './logo.model';
import { Remittance } from './remittance.model';
import { Template } from './template.model';

export const RENDERING_SCHEMA = Object.freeze({
    LOGO: null, // Logo
    TEMPLATE: Template,
    LABELS: Labels,
    ADDITIONAL_IMAGE: null, // AdditionalImage
    REMITTANCE: null,
  }),
  RECORD = generateSchema(RENDERING_SCHEMA),
  KEYS: any = generateKeys(RENDERING_SCHEMA);

export class Rendering extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.LOGO,
        value: props.get(KEYS.LOGO) ? new Logo(this.logo) : null,
      },
      {
        key: KEYS.TEMPLATE,
        value: new Template(this.template),
      },
      {
        key: KEYS.LABELS,
        value: new Labels(this.labels),
      },
      {
        key: KEYS.ADDITIONAL_IMAGE,
        value: props.get(KEYS.ADDITIONAL_IMAGE)
          ? new AdditionalImage(this.additionalImage)
          : null,
      },
      {
        key: KEYS.REMITTANCE,
        value: new Remittance(this.remittance),
      },
    ]);

    return selfModel as Rendering;
  }

  get logo(): Logo {
    return this.get(KEYS.LOGO);
  }

  get template(): Template {
    return this.get(KEYS.TEMPLATE);
  }

  get additionalImage(): AdditionalImage {
    return this.get(KEYS.ADDITIONAL_IMAGE);
  }

  get labels(): Labels {
    return this.get(KEYS.LABELS);
  }

  get remittance(): Remittance {
    return this.get(KEYS.REMITTANCE);
  }
}
